import React from 'react';
import PropTypes from 'prop-types';
import { SplitDateRangePicker } from '@eb/eds-date-picker';
import { STYLE_STATIC } from '@eb/eds-input-field';
import { ValidationFormField } from '@eb/eds-validation-form-field';
import { datePropType } from '@eb/eds-utils';
import { translationPropType } from '@eb/i18n';

export default class ValidatedDate extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        label: translationPropType,
        startDate: datePropType,
        endDate: datePropType,
        minDate: datePropType,
        maxDate: datePropType,
        isEndInput: PropTypes.bool,
        required: PropTypes.bool,
    };

    render() {
        const {
            id,
            name,
            label,
            startDate,
            endDate,
            minDate,
            maxDate,
            isEndInput,
            required,
        } = this.props;

        return (
            <ValidationFormField
                id={id}
                name={name}
                label={label}
                startDate={startDate}
                endDate={endDate}
                minDate={minDate}
                maxDate={maxDate}
                v2={true}
                required={required}
            >
                <SplitDateRangePicker
                    isEndInput={isEndInput}
                    style={STYLE_STATIC}
                />
            </ValidationFormField>
        );
    }
}
